module.exports = __webpack_public_path__ + "images/6ff5f06f720322f77d89d9425e452e4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro/header_barcelona.jpg
// module id = 65
// module chunks = 24